import React, { useMemo, useState, useEffect } from 'react';
import classnames from 'classnames';
import moment from 'moment';
import qs from 'query-string';

import { formatDay } from '~helpers/day';
import { imageUrl } from '~helpers/gallery';
import CityTag from '../tag';
import DeleteBannerModal from '../delete-banner-modal';

export default function ListItem({
  itemData,
  currentIndex,
  t,
  deleteBanner,
  editBanner,
  cityName,
  setCurrentBannerId,
  adjustBannerPositions,
  preBannerId,
  displayBannerIds,
}) {
  const { cityId } = qs.parse(window.location.search);
  const [visible, setVisible] = useState(false);
  const [isActive, setIsActive] = useState(false);
  const [isExpire, setIsExpire] = useState(false);

  const tagType = useMemo(() => {
    if (itemData.country?.name) {
      return 'single';
    } else if (itemData.cities?.length) {
      return 'many';
    } else if (itemData.allCountries) {
      return 'all';
    }
  }, [itemData.allCountries, itemData.cities]);

  const handleMoveUp = () => {
    adjustBannerPositions({
      variables: {
        input: {
          cityId,
          bannerIds: [preBannerId, itemData.id],
        },
      },
    });
  };

  useEffect(() => {
    const hasActiveBanner = displayBannerIds.some(banner => banner.id === itemData.id);
    setIsExpire(moment(itemData.effectiveEndDate).isBefore(moment()));
    setIsActive(hasActiveBanner);
  }, [itemData]);

  return (
    <div className={classnames('list-item-wrapper', isActive && 'active-wrapper')}>
      <div className="item-image-wrapper">
        <div className={classnames('index', !isActive && 'inactive')}>{currentIndex + 1}</div>
        <div className="banner-wrapper">
          <img
            className="banner"
            src={imageUrl(
              {
                source: `${itemData.filename}-${itemData.imageHash}.${itemData.extension}`,
              },
              { width: 373, height: 160 },
            )}
            alt="banner-image"
          />
          <If condition={isActive}>
            <div className="display-tag">Display on S.com</div>
          </If>
        </div>
      </div>
      <div className="item-padding link">{itemData.link}</div>
      <div className="item-padding date" style={{ paddingLeft: 36 }}>
        {`${formatDay('MMM, DD YYYY', itemData.effectiveStartDate)} - ${formatDay(
          'MMM, DD YYYY',
          itemData.effectiveEndDate,
        )}`}
      </div>
      <div className="item-padding">
        <CityTag city={itemData.cities} country={itemData.country} type={tagType} />
      </div>
      <div className="item-padding date">{`${formatDay('MMM, DD YYYY', itemData.updatedAt)} by ${
        itemData.updatedUser?.firstName
      } ${itemData.updatedUser?.lastName}`}</div>
      <div className="item-padding actions">
        <div
          className="edit"
          onClick={() => {
            editBanner();
            setCurrentBannerId(itemData.id);
          }}
        >
          Edit
        </div>
        <If condition={currentIndex !== 0 && !isExpire}>
          <div className="move-up" onClick={handleMoveUp}>
            Move up
          </div>
        </If>
        <div
          className="delete"
          onClick={() => {
            setCurrentBannerId(itemData.id);
            setVisible(true);
          }}
        >
          Delete
        </div>
      </div>
      <If condition={visible}>
        <DeleteBannerModal
          visible={visible}
          onClose={() => setVisible(false)}
          t={t}
          deleteBanner={deleteBanner}
          cityName={cityName}
          bannerData={itemData}
        />
      </If>
    </div>
  );
}
